import { Component } from '@angular/core';
import { CfetBaseComponent } from 'src/app/cfet-core';

@Component({
    selector: 'app-custom-spinner',
    templateUrl: './custom-spinner.component.html',
    styleUrls: ['./custom-spinner.component.scss'],
    standalone: false
})
export class CustomSpinnerComponent extends CfetBaseComponent {

  constructor() { super(); }


}
